import { combineReducers } from "redux";
import { viewModeValue } from "./viewModeReducer";
import { trailerViewMode } from "./trailerModeReducer";
import { cartReduceHandler } from "./cartReducer";
import { loginViewMode } from "./loginViewReducer";
import { logindataValue } from "./logindataReducer";
import { movieDetailsViewMode } from "./viewMovieDetailsReducers";
import { mobileFilterReduce } from "./mobileFilterReducer";
import { nowShowingMoviesReduce } from "./nowShowingMoviesReaducers";
import { MobilenowShowingMoviesReduce } from "./MobilenowShowingMoviesReaducers";
import { comingSoonMovieReduce } from "./comingsoonMoviesReducers";
import { grandTotalData } from "./grandTotalReducers";
import { cityChangeData } from "./cityReducer";
import { addToCartReduceHandler } from "./addToCartReducer"; //AurusIt Developer
import { showTimeViewMode } from "./showtimeReducer";
import { bankofferViewMode } from "./bankofferReducer";
import {superticketReducer} from "./SuperticketReducer";
import{singlepagevoucherlistingReducer} from "./SinglePageVoucherListingReducer"
// import { haptikViewMode } from "./haptikViewReducer";

export default combineReducers({
  viewModeValue,
  trailerViewMode,
  cartReduceHandler,
  addToCartReduceHandler, //AurusIt Developer
  loginViewMode,
  movieDetailsViewMode,
  mobileFilterReduce,
  nowShowingMoviesReduce,
  comingSoonMovieReduce,
  grandTotalData,
  cityChangeData,
  showTimeViewMode, 
  bankofferViewMode,
  superticketReducer, 
  logindataValue,
  MobilenowShowingMoviesReduce,
  singlepagevoucherlistingReducer,
  // haptikViewMode,
  
  
});
